export interface RefreshTokenResult {
	success: boolean;
	access_token?: string;
	refresh_token?: string;
	expires_in?: number;
}

export async function attemptTokenRefresh(
	tokenEndpoint: string,
	clientId: string,
	refreshToken: string
): Promise<RefreshTokenResult> {
	const response = await fetch(tokenEndpoint, {
		method: "POST",
		headers: {
			"Content-Type": "application/x-www-form-urlencoded"
		},
		body: new URLSearchParams({
			client_id: clientId,
			grant_type: "refresh_token",
			refresh_token: refreshToken
		})
	});

	if (!response.ok) {
		return {success: false};
	}

	const data = await response.json();
	return {
		success: true,
		access_token: data.access_token,
		refresh_token: data.refresh_token,
		expires_in: data.expires_in
	};
}
